/**
 * Les lectures de la semaine des lives : aucune au montage — l'ancienne modale lisait les séances du
 * compte, que la coquille relit à chaque prise de focus. « Rafraîchir » relit le compte (`getUser`),
 * qui porte `live_sessions` ; la flèche de l'en-tête tourne le temps de la relecture. Un refus se dit
 * dans le `<Snackbar>` de la page (`useGestureNotice`) : la boîte « Erreur » de la coquille legacy se tait
 * sous l'espace tuteur.
 */
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { useGestureNotice } from "../../../hooks/useGestureNotice"

/** Ce que dit « Rafraîchir » refusé sans message du serveur : en pratique, le réseau. */
export const TUTOR_LIVES_REFRESH_FAILED = "Ta semaine n'a pas pu être rafraîchie. Vérifie ta connexion puis réessaie."

export function useTutorLivesListData() {
    const dispatch = useDispatch()
    const { notice, dismiss: dismissNotice, readOptions } = useGestureNotice(TUTOR_LIVES_REFRESH_FAILED)
    const refresh = useCallback(() => {
        dispatch(apiRequest(authService.getUser, {}, {}, {}, null, null, readOptions()) as never)
    }, [dispatch, readOptions])
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const refreshing = useSelector((state: any) => !!state?.api?.getUser?.request)
    return { refresh, refreshing, notice, dismissNotice }
}
